import React from "react";
import { Assets } from "../../assets";
import { menuSelect } from "../../types/initStore/initUi";
import { ButtonSecondary } from "../Button/ButtonSecondary";
import { CardLocation } from "../Card/CardLocation";
import { NotificationInit } from "../Notification/NotificationInit";
import { NotificationTutorial } from "../Notification/NotificationTutorial";

export const ContainerMobile = ({
	optionSelect = 0,
	selectMenu = menuSelect.principal,
	cardLocationMenu = [],
	nameselect = "Edificios",
	actionOptionMenu = () => {
		console.log("select");
	},
	backMenu = () => {
		console.log("menu1");
	},
	actionMoveLocation = () => {
		console.log("menu1");
	},
	actionModalInformation = () => {
		console.log("modal");
	},
}) => {
	return (
		<>
			<div className="bg-grayBackground70 border-t-4 h-[220px] border-secondary w-full grid grid-rows-containerMenuMobile relative">
				<NotificationTutorial />
				<NotificationInit />
				<div className={`w-full h-10 absolute z-10 -top-8 pl-3 `}>
					<img className="h-full w-full" src={Assets.general.simbolomovil} alt="simbolo" />
				</div>
				<div className="bg-white70 overflow-hidden flex justify-center flex-col items-center">
					<p className="text-secondary text-[14px]">Bienvenido a tu recorrido 360 en la</p>
					<p className="text-[14px]">Universidad Autonoma Metropolitana</p>
				</div>
				<div className="overflow-x-auto flex gap-4 items-center px-4">
					{cardLocationMenu.map(({ id, name, menuSelect: menu, background, icon }, index) => (
						<CardLocation
							icon={icon}
							selectId={optionSelect}
							key={`${index}-cardLocation`}
							name={name}
							id={id}
							background={background}
							action={() => {
								if (selectMenu === menuSelect.principal) {
									actionOptionMenu(id, menu);
								} else if (selectMenu === menuSelect.secondary) {
									actionMoveLocation(id);
								} else {
									actionModalInformation(true, id, `move-${index}`);
								}
							}}
						/>
					))}
				</div>
				<div className="flex flex-col items-center bg-grayGeneral">
					{selectMenu === menuSelect.principal ? (
						<>
							{/* <img className="w-[80%]" src={Assets.arrow} alt="arrow" />
							<span className="xsm:text-[12px]">Desliza para conocer mas</span> */}
						</>
					) : (
						<>
							<div className="pt-1.5">
								<ButtonSecondary name="regresar" action={backMenu} />
							</div>
						</>
					)}
				</div>
			</div>
		</>
	);
};
